'use strict';
import Vue from 'vue'
import Main from './modules/Main.vue'
new Vue({
	data: {
		tplData: JSON.parse(JSON.stringify(tplData))
	},
	render: h => h(Main, {
		props: {
			tplData: JSON.parse(JSON.stringify(tplData))
		}
	})
}).$mount('#app');



// WEBPACK FOOTER //
// ./public/vue/category/index.js